module.exports = __webpack_public_path__ + "Frame411-8e9da72e.webp";